





















































































































































import MarketSelect from '@/components/MarketSelect.vue';
import MultiSelect from '@/components/MultiSelect.vue';
import Http from '@/mixins/http';
import {Component, Mixins, Prop} from 'vue-property-decorator';
import vSelect from '@/components/UI/vSelect.vue';
import CSelect from '@/components/UI/CoefficientSelect.vue';
import LocalData from '@/mixins/local-data';
import Toast from '@/mixins/toast';
import CollapseCard from "@/components/UI/CollapseCard.vue"
import Card from '@/components/UI/Card.vue';
import SwitchWithLabel from '@/components/UI/SwitchWithLabel.vue';
import {SelectBox, TaskInfoCalc} from "@/interfaces/global-data";
import {GetTaskInfo, PackagePromoConfig, TaskData, TaskInfoFilterType} from "@/interfaces/server-data";
import {EventBus} from "@/mixins/event-bus";
import RecommendationReportsList from '@/pages/ModuleItems/ModuleTabs/RecommendationsTab/RecommendationReportsList.vue';

@Component({
    components: {
        MarketSelect,
        MultiSelect,
        vSelect,
        CollapseCard,
        Card,
        CSelect,
        SwitchWithLabel,
        RecommendationReportsList,
    },
})
export default class Recommendations extends Mixins(LocalData, Toast, Http) {
    @Prop({required: true}) readonly activeTabKey: string = '' as string;

    defaultIntSelectBox: Array<SelectBox<number>> = [{value: 0, label: this.$t('shared.selectBox.all') as string}];

    taskInfoRecommends: TaskInfoCalc = {
        storeFormatOptions: [],
        storeRegionOptions: [],
        buyerSegmentOptions: [],
        categoryOptions: [],
        clusterOptions: [],
        groupsOfProduct: [],
        subcategories: [],
        subcategoriesDefault: [],
        psegemnts: [],
    };

    private dropDownOpen = false;
    onDropdownClosed: Function | null = null;

    get isGroupsRecommendsSelected(): boolean {
        const groups = LocalData.filterNumberArrays(this.$packagePromoRecommends.groupsOfProduct);
        return groups != null && groups.length > 0;
    }

    get isCategoriesSelected(): boolean {
        const categories = LocalData.filterNumberArrays(this.$packagePromoRecommends.categoriesOfProduct);
        return categories != null && categories.length > 0;
    }

    get isSubcategorySelectedRecommends(): boolean {
        const subcategories = LocalData.filterNumberArrays(this.$packagePromoRecommends.subcategories);
        return subcategories != null && subcategories.length!! > 0;
    }

    get isFormatSelected(): boolean {
        const formats = LocalData.filterNumberArrays(this.$packagePromoRecommends.formatSelected);
        return formats != null && formats.length > 0;
    }

    get isRegionsSelected(): boolean {
        const regions = LocalData.filterNumberArrays(this.$packagePromoRecommends.regionSelected);
        return regions != null && regions.length > 0;
    }

    get calcButtRecommends(): boolean {
        return this.calcButtonStateForSearchRecommends();
    }

    get promoRecommendsCalculationDepthValidate(): boolean {
        return this.$packagePromoRecommends.calculationDepth * 7 >= this.$packagePromoRecommends.calculationDay;
    }

    get promoRecommendsCalculationDayValidate(): boolean {
        return this.$packagePromoRecommends.calculationDay > 0;
    }

    mounted() {
        // в PromoCalc эти действия происходили при обновлении ТК в селекте, т.к. в этом модуле при смене ТК ренедерятся все компоненты полностью, именно на mounted это и нужно делать
        this.resetPackagePromoRecommendsData();
        Object.assign(this.$packagePromoRecommends.selectMarket, this.$promotions.selectMarket); // вместо того, что в старом модуле вручную выбирали ТК в селекте для $packagePromoRecommends
        this.initTaskRecommends();
        this.savePackagePromoRecommends();

        if (this.$packagePromoRecommends.selectMarket.id !== -1) {
            const self = this;
            (this.$refs.recommendsCategoriesSelectedRef as any).toggleLoading(true);
            (this.$refs.updateRegionsRecommendsRef as any).toggleLoading(true);
            (this.$refs.updateRecommendsSeasonsRef as any).toggleLoading(true);
            (this.$refs.updateBuyerSegmentsRecommendsRef as any).toggleLoading(true);
            (this.$refs.recommendsFormatSelectedRef as any).toggleLoading(true);
            (this.$refs.recommendsClusterSelectedRef as any).toggleLoading(true);
            (this.$refs.recommendsGroupSelectedRef as any).toggleLoading(true);
            (this.$refs.recommendsSubcategoriesRef as any).toggleLoading(true);
            (this.$refs.recommendsProductSegmentsRef as any).toggleLoading(true);
            this.getCategoryInfoRecommends();
            self.getRegionInfoRecommends();
            self.getFormatInfoRecommends();
            self.getBuyerSegmentRecommends();
            self.getClusterInfoRecommends();
            self.loadProductsGroupRecommends();
            self.loadProductsSubcategoriesRecommends();
            self.loadProductSegmentsRecommends();
        }

        EventBus.$on('packagePromoRecommends', this.onCalcEventReceived);
    }

    selectDataRecommends(): [number[], number[], number[], number[]] {
        const selectSeasons: number[] = (this.$packagePromoRecommends.seasonSelected.length === 0 || (this.$packagePromoRecommends.seasonSelected.length === 1 && this.$packagePromoRecommends.seasonSelected[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$packagePromoRecommends.seasonSelected)!!;
        const selectRegions: number[] = (this.$packagePromoRecommends.regionSelected.length === 0 || (this.$packagePromoRecommends.regionSelected.length && this.$packagePromoRecommends.regionSelected[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$packagePromoRecommends.regionSelected)!!;
        const selectBuyerSegment: number[] = (this.$packagePromoRecommends.buyerSegmentsList.length === 0 || (this.$packagePromoRecommends.buyerSegmentsList.length && this.$packagePromoRecommends.buyerSegmentsList[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$packagePromoRecommends.buyerSegmentsList)!!;
        const selectFormats: number[] = (this.$packagePromoRecommends.formatSelected.length === 0 || (this.$packagePromoRecommends.formatSelected.length && this.$packagePromoRecommends.formatSelected[0] === 0))
            ? []
            // tslint:disable-next-line: no-non-null-assertion
            : LocalData.filterNumberArrays(this.$packagePromoRecommends.formatSelected)!!;
        return [selectSeasons, selectRegions, selectBuyerSegment, selectFormats];
    }

    private getTaskInfoRecommends(filterType: TaskInfoFilterType): GetTaskInfo {
        const [, selectRegions, , selectFormats] = this.selectDataRecommends();
        return {
            type: filterType,
            tradingId: this.$packagePromoRecommends.selectMarket.id,
            categories: LocalData.filterNumberArrays(this.$packagePromoRecommends.categoriesOfProduct),
            groups: LocalData.filterNumberArrays(this.$packagePromoRecommends.groupsOfProduct),
            subcategory: LocalData.filterNumberArrays(this.$packagePromoRecommends.subcategories, true),
            segments: null,
            storeFormat: selectFormats,
            storeCluster: this.$packagePromoRecommends.clusterSelected,
            storeRegion: selectRegions,
            byReports: false,
        }
    }

    getCategoryInfoRecommends(cb: any = null) {
        this.httpGetProductInfo(this.getTaskInfoRecommends(TaskInfoFilterType.category))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    (this.$refs.recommendsCategoriesSelectedRef as any).toggleLoading(false);
                    (this.$refs.updateRecommendsSeasonsRef as any).toggleLoading(false);
                }, 250);
                this.taskInfoRecommends.categoryOptions = filterData.categories.map((i) => {
                    return {value: i.id, label: i.name}
                });
                this.taskInfoRecommends.categoryOptions.unshift();
                if (typeof cb === 'function') {
                    cb();
                }
            })
            .catch((e) => {
            })
    }

    loadProductsSubcategoriesRecommends() {
        this.httpGetProductInfo(this.getTaskInfoRecommends(TaskInfoFilterType.subcategory))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    (this.$refs.recommendsSubcategoriesRef as any).toggleLoading(false);
                }, 250);
                this.taskInfoRecommends.subcategories = filterData.subcategories.map((i) => {
                    return {value: i.id, label: i.name}
                });
                this.taskInfoRecommends.subcategories.unshift({value: 0, label: this.$t('shared.selectBox.all') as string})
            })
            .catch((e) => {
            })
    }

    loadProductSegmentsRecommends() {
        this.httpGetProductInfo(this.getTaskInfoRecommends(TaskInfoFilterType.p_segemnt))
            .then(data => {
                const filterData = data.data;
                setTimeout(() => {
                    (this.$refs.recommendsProductSegmentsRef as any).toggleLoading(false);
                }, 250);
                this.taskInfoRecommends.psegemnts = filterData.psegments.map(i => {
                    return {
                        label: i.name,
                        value: i.id
                    };
                });

                // TODO не переносил taskInfo, т.к. в PromoCalc это был объект опций для параметров один во всём модуле - а теперь в новом модуле Промо много сущностей промо, нужно разбираться с логикой работы в принципе и явно дорабатывать функционал
                // this.taskInfo.psegemnts.unshift({ value: 0, label: this.$t('shared.selectBox.all') as string })
            })
            .catch(e => { });
    }

    showCalcProgress(status: string): boolean {
        return (status === 'WriteToFileComplete'
            || status === 'EmptyData'
            || status === 'ExecutionException'
            || status === 'PromoNotRecommended'
            || status.includes('Error'));
    }

    onCalcEventReceived(data: TaskData) { // в таком виде из PromoCalc
        if (this.showCalcProgress(data.status)) {
        }
    }

    getFormatInfoRecommends() {
        this.httpGetProductInfo(this.getTaskInfoRecommends(TaskInfoFilterType.format))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    (this.$refs.recommendsFormatSelectedRef as any).toggleLoading(false);
                }, 500);
                this.taskInfoRecommends.storeFormatOptions = filterData.storeFormat.map((i) => {
                    return {value: i.id, label: i.name};
                });
            })
            .catch((e) => {
            });
    }

    getBuyerSegmentRecommends() {
        this.httpGetProductInfo(this.getTaskInfoRecommends(TaskInfoFilterType.buyer))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    (this.$refs.updateBuyerSegmentsRecommendsRef as any).toggleLoading(false);
                }, 500);

                this.taskInfoRecommends.buyerSegmentOptions = filterData.buyerSegments.map((i) => {
                    return {value: i.id, label: i.name};
                });

            })
            .catch((e) => {
            });
    }

    getRegionInfoRecommends() {
        this.httpGetProductInfo(this.getTaskInfoRecommends(TaskInfoFilterType.region))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    (this.$refs.updateRegionsRecommendsRef as any).toggleLoading(false);

                }, 500);

                this.taskInfoRecommends.storeRegionOptions = filterData.storeRegion.map((i) => {
                    return {value: i.id, label: i.name};
                });
                this.taskInfoRecommends.storeRegionOptions = [{
                    value: 0,
                    label: this.$t('shared.selectBox.all') as string,
                }, ...this.taskInfoRecommends.storeRegionOptions];
            })
            .catch((e) => {
            });
    }

    getClusterInfoRecommends() {
        this.httpGetProductInfo(this.getTaskInfoRecommends(TaskInfoFilterType.cluster))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    (this.$refs.recommendsClusterSelectedRef as any).toggleLoading(false);
                }, 500);

                this.taskInfoRecommends.clusterOptions = filterData.storeCluster.map((i) => {
                    return {value: i.id, label: i.name};
                });
            })
            .catch((e) => {
            });
    }

    loadProductsGroupRecommends() {
        this.httpGetProductInfo(this.getTaskInfoRecommends(TaskInfoFilterType.group))
            .then((data) => {
                const filterData = data.data;
                setTimeout(() => {
                    (this.$refs.recommendsGroupSelectedRef as any).toggleLoading(false);
                }, 250);
                this.taskInfoRecommends.groupsOfProduct = filterData.groups.map((i) => {
                    return {value: i.id, label: i.name}
                });
                this.taskInfoRecommends.groupsOfProduct.unshift({value: 0, label: this.$t('shared.selectBox.all') as string});
            })
            .catch((e) => {
            })
    }

    initTaskRecommends() {
        if (this.$packagePromoRecommends.selectMarket.id === -1) {
            return;
        }
        (this.$refs.updateRegionsRecommendsRef as any).toggleLoading(true);
        (this.$refs.updateRecommendsSeasonsRef as any).toggleLoading(true);
        (this.$refs.updateBuyerSegmentsRecommendsRef as any).toggleLoading(true);
        (this.$refs.recommendsFormatSelectedRef as any).toggleLoading(true);
        (this.$refs.recommendsCategoriesSelectedRef as any).toggleLoading(true);
        (this.$refs.recommendsClusterSelectedRef as any).toggleLoading(true);
        (this.$refs.recommendsGroupSelectedRef as any).toggleLoading(true);
        (this.$refs.recommendsSubcategoriesRef as any).toggleLoading(true);
        (this.$refs.recommendsProductSegmentsRef as any).toggleLoading(true);

        this.$packagePromoRecommends.categoriesOfProduct = [];
        this.$packagePromoRecommends.clusterSelected = [];
        this.$packagePromoRecommends.formatSelected = [];
        this.$packagePromoRecommends.groupsOfProduct = [];
        this.$packagePromoRecommends.subcategories = [];
        this.$packagePromoRecommends.productSegments = [];
        this.taskInfoRecommends.storeFormatOptions = [];
        this.taskInfoRecommends.storeRegionOptions = [];
        this.taskInfoRecommends.buyerSegmentOptions = [];
        this.taskInfoRecommends.categoryOptions = [];
        this.taskInfoRecommends.clusterOptions = [];
        this.taskInfoRecommends.psegemnts = [];
        this.taskInfoRecommends.subcategories = [];
        this.taskInfoRecommends.groupsOfProduct = [{value: null, label: this.$t('shared.selectBox.all') as string}];
        const self = this;
        this.getCategoryInfoRecommends(() => {
            self.loadProductsGroupRecommends();
            self.getRegionInfoRecommends();
            self.getFormatInfoRecommends();
            self.getBuyerSegmentRecommends();
            self.getClusterInfoRecommends();
            self.loadProductsSubcategoriesRecommends();
            self.loadProductSegmentsRecommends();
        });
    }

    resetDataRecommends(type: TaskInfoFilterType) {
        switch (type) {
            case TaskInfoFilterType.group:
                this.$packagePromoRecommends.categoriesOfProduct = [];
                this.$packagePromoRecommends.subcategories = this.defaultIntSelectBox.map(i => i.value);
                this.$packagePromoRecommends.formatSelected = this.defaultIntSelectBox.map(i => i.value);
                this.$packagePromoRecommends.regionSelected = this.defaultIntSelectBox.map(i => i.value);
                this.$packagePromoRecommends.clusterSelected = this.defaultIntSelectBox.map(i => i.value);
                this.$packagePromoRecommends.productSegments = this.defaultIntSelectBox.map(i => i.value);
                this.taskInfoRecommends.categoryOptions = [];
                this.taskInfoRecommends.subcategories = [];
                this.taskInfoRecommends.psegemnts = [];
                this.taskInfoRecommends.storeFormatOptions = [];
                this.taskInfoRecommends.storeRegionOptions = [];
                this.taskInfoRecommends.clusterOptions = [];
                this.getCategoryInfoRecommends(null);
                this.loadProductsSubcategoriesRecommends();
                this.loadProductSegmentsRecommends();
                this.getFormatInfoRecommends();
                this.getRegionInfoRecommends();
                this.getClusterInfoRecommends();
                break;
            case TaskInfoFilterType.category:
                this.$packagePromoRecommends.subcategories = this.defaultIntSelectBox.map(i => i.value);
                this.$packagePromoRecommends.formatSelected = this.defaultIntSelectBox.map(i => i.value);
                this.$packagePromoRecommends.regionSelected = this.defaultIntSelectBox.map(i => i.value);
                this.$packagePromoRecommends.clusterSelected = this.defaultIntSelectBox.map(i => i.value);
                this.$packagePromoRecommends.productSegments = this.defaultIntSelectBox.map(i => i.value);
                this.taskInfoRecommends.subcategories = [];
                this.taskInfoRecommends.psegemnts = [];
                this.taskInfoRecommends.storeFormatOptions = [];
                this.taskInfoRecommends.storeRegionOptions = [];
                this.taskInfoRecommends.clusterOptions = [];
                this.loadProductsSubcategoriesRecommends();
                this.loadProductSegmentsRecommends();
                this.getFormatInfoRecommends();
                this.getRegionInfoRecommends();
                this.getClusterInfoRecommends();
                break;
            case TaskInfoFilterType.subcategory:
                this.$packagePromoRecommends.formatSelected = this.defaultIntSelectBox.map(i => i.value);
                this.$packagePromoRecommends.regionSelected = this.defaultIntSelectBox.map(i => i.value);
                this.$packagePromoRecommends.clusterSelected = this.defaultIntSelectBox.map(i => i.value);
                this.$packagePromoRecommends.productSegments = this.defaultIntSelectBox.map(i => i.value);
                this.taskInfoRecommends.psegemnts = [];
                this.taskInfoRecommends.storeFormatOptions = [];
                this.taskInfoRecommends.storeRegionOptions = [];
                this.taskInfoRecommends.clusterOptions = [];
                this.loadProductSegmentsRecommends();
                this.getFormatInfoRecommends();
                this.getRegionInfoRecommends();
                this.getClusterInfoRecommends();
                break;
            case TaskInfoFilterType.p_segemnt:
                this.$packagePromoRecommends.formatSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$packagePromoRecommends.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$packagePromoRecommends.clusterSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfoRecommends.storeFormatOptions = [];
                this.taskInfoRecommends.storeRegionOptions = [];
                this.taskInfoRecommends.clusterOptions = [];
                this.getFormatInfoRecommends();
                this.getRegionInfoRecommends();
                this.getClusterInfoRecommends();
                break;
            case TaskInfoFilterType.format:
                this.$packagePromoRecommends.regionSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.$packagePromoRecommends.clusterSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfoRecommends.storeRegionOptions = [{ value: 0, label: this.$t("shared.selectBox.all") as string }];
                this.taskInfoRecommends.clusterOptions = [];
                this.loadProductSegmentsRecommends();
                this.getRegionInfoRecommends();
                this.getClusterInfoRecommends();
                break;
            case TaskInfoFilterType.region:
                this.$packagePromoRecommends.clusterSelected = this.defaultIntSelectBox.map((i) => i.value);
                this.taskInfoRecommends.clusterOptions = [];
                this.loadProductSegmentsRecommends();
                this.getClusterInfoRecommends();
                break;
        }
    }

    updateProductGroupRecommends(groupOfProduct: number[]) {
        if (groupOfProduct.length > 0 && !LocalData.compareTwoArrays(groupOfProduct, this.$packagePromoRecommends.groupsOfProduct)) {
            this.$packagePromoRecommends.groupsOfProduct = groupOfProduct;
            this.savePackagePromoRecommends();
            this.resetDataRecommends(TaskInfoFilterType.group);
        }
    }

    updateProductCategoryRecommends(categories: number[]) {
        if (categories.length > 0 && !LocalData.compareTwoArrays(categories, this.$packagePromoRecommends.categoriesOfProduct)) {
            this.$packagePromoRecommends.categoriesOfProduct = categories;
            this.resetDataRecommends(TaskInfoFilterType.category);
            this.savePackagePromoRecommends();
        }
    }

    updateSubcategoriesRecommends(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$packagePromoRecommends.subcategories)) {
            this.$packagePromoRecommends.subcategories = list;
            this.savePackagePromoRecommends();
            this.resetDataRecommends(TaskInfoFilterType.subcategory);
        }
    }

    updateProductSegmentsRecommends(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$packagePromoRecommends.productSegments)) {
            this.$packagePromoRecommends.productSegments = list;
            this.savePackagePromoRecommends();
            this.resetDataRecommends(TaskInfoFilterType.p_segemnt);
        }
    }

    updateFormatRecommends(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$packagePromoRecommends.formatSelected)) {
            this.$packagePromoRecommends.formatSelected = list;
            this.resetDataRecommends(TaskInfoFilterType.format);
            this.savePackagePromoRecommends();
        }
    }

    updateRegionsRecommends(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$packagePromoRecommends.regionSelected)) {
            this.$packagePromoRecommends.regionSelected = list;
            this.resetDataRecommends(TaskInfoFilterType.region);
            this.savePackagePromoRecommends();
        }
    }

    updateClustersRecommends(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$packagePromoRecommends.clusterSelected)) {
            this.$packagePromoRecommends.clusterSelected = list;
            this.resetDataRecommends(TaskInfoFilterType.cluster);
            this.savePackagePromoRecommends();
        }
    }

    updateBuyerSegmentsRecommends(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$packagePromoRecommends.buyerSegmentsList)) {
            this.$packagePromoRecommends.buyerSegmentsList = list;
            this.savePackagePromoRecommends();
        }
    }

    updateSeasonsRecommends(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.$packagePromoRecommends.seasonSelected)) {
            this.$packagePromoRecommends.seasonSelected = list;
            this.savePackagePromoRecommends();
        }
    }

    onMultiSelectToggle(open: boolean) {
        this.dropDownOpen = open;
        if (!open) {
            if (this.onDropdownClosed != null) {
                this.onDropdownClosed.apply(open);
            }
        }
    }

    searchPackagePromoRecommends() {
        const filters = this.getPackagePromoRecommendsFilter();
        this.savePackagePromoRecommends();
        this.httpAddPackagePromoRecommendsTask(filters)
            .then((r) => {
                this.showInfo(this.$t('shared.recommendations.calcStarted') as string);
                this.$log.debug('Create task', r.data);

                (this.$refs.recommendationReportsList as RecommendationReportsList).fetchList({
                    currentPage: 1,
                    perPage: 20,
                }, () => {});
            })
            .catch((e) => {
                this.showError(this.$t('shared.parametersTab.errorStartCalc') as string);
            });
    }

    getPackagePromoRecommendsFilter(): PackagePromoConfig {
        const [selectSeasons, selectRegions, selectBuyerSegment, selectFormats] = this.selectDataRecommends();
        const selectClusters: number[] = (this.$packagePromoRecommends.clusterSelected.length === 0 || (this.$packagePromoRecommends.clusterSelected.length && this.$packagePromoRecommends.clusterSelected[0] === 0))
            // tslint:disable-next-line: no-non-null-assertion
            ? [] : LocalData.filterNumberArrays(this.$packagePromoRecommends.clusterSelected)!!;
        return {
            tradingId: this.$packagePromoRecommends.selectMarket.id,
            // tslint:disable-next-line: no-non-null-assertion
            categories: LocalData.filterNumberArrays(this.$packagePromoRecommends.categoriesOfProduct)!!,
            productSegments: LocalData.filterNumberArrays(this.$packagePromoRecommends.productSegments)!!,
            storeCluster: selectClusters,
            seasonValues: selectSeasons,
            buyerSegments: selectBuyerSegment,
            storeRegionValues: selectRegions,
            storeFormat: selectFormats,
            // tslint:disable-next-line: no-non-null-assertion
            groupsOfProduct: LocalData.filterNumberArrays(this.$packagePromoRecommends.groupsOfProduct)!!,
            // tslint:disable-next-line: no-non-null-assertion
            subcategories: LocalData.filterNumberArrays(this.$packagePromoRecommends.subcategories),
            separateSubcategories: this.$packagePromoRecommends.separateSubcategories,
            separateClusters: this.$packagePromoRecommends.separateClusters,
            categoryStrategy: this.$packagePromoRecommends.categoryStrategy.value,
            calculationDepth: this.$packagePromoRecommends.calculationDepth,
            calculationDay: this.$packagePromoRecommends.calculationDay,
            manualPennies: this.$packagePromoRecommends.manualPennies,
            calcWithBatchNumber: false,
            thompsonSampling: false,
            applyOmnichannel: false,
            sendGeneralReportNotification: localStorage.getItem('sendGeneratedReportNotification') === 'true',
            isFixPricePromo: this.$packagePromoRecommends.isFixPricePromo,
            useSkuRotation: this.$promo.useSkuRotation,
            useFixedPrices: true,
        };
    }

    calcButtonStateForSearchRecommends(): boolean {
        if (this.$packagePromoRecommends.selectMarket != null) {
            const state = this.isGroupsRecommendsSelected;
            return !state;
        }
        return true;
    }
}
